import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import PropertyInfo from './PropertyInfo';
import SellingProfile from './SellingProfile';
import BuyingProfile from './BuyingProfile';
import Documents from './Documents';
import StatusBadge from '../../common/Fields/StatusBadge';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { withRouter } from 'react-router';
import VettingQuestions from './VettingQuestions';
import { addressConcat } from '../../../helpers';

import linkIcon from '../../../assets/img/svg/referral/linkIcon.svg';
import buyerProfileIcon from '../../../assets/img/svg/referral/BuyerProfileIcon.svg';
import vettingQuestionsIcon from '../../../assets/img/svg/referral/VettingQuestionsIcon.svg';
import propertyIcon from '../../../assets/img/svg/referral/PropertyIcon.svg';
import notesIcon from '../../../assets/img/svg/referral/NotesIcon.svg';
import documentsIcon from '../../../assets/img/svg/referral/documentsIcon.svg';
import addIcon from '../../../assets/img/svg/referral/AddIcon.svg';

class Opportunities extends Component {
  static propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    documents: PropTypes.array,
    userprofile: PropTypes.object,
    addPropertyClickHandler: PropTypes.func,
    setActiveOpportunity: PropTypes.func,
    history: PropTypes.object,
    showDocumentModal: PropTypes.func.isRequired,
    showReasonModal: PropTypes.func,
    showDocInModal: PropTypes.bool.isRequired,
    referral: PropTypes.object.isRequired,
    additionalDocuments: PropTypes.array,
    markOpportunityDocumentRead: PropTypes.func.isRequired
  };

  redirectToWeeklyStatusUpdate = async () => {
    if (_.get(this.props.opportunity, 'group', null) === 'CLOSED') {
      return false;
    }

    const contactId = _.get(this.props.opportunity, 'contactKey', null);
    const opportunityId = _.get(this.props.opportunity, 'opportunityKey', null);

    await this.props.setActiveOpportunity(this.props.opportunity);
    this.props.history.push(`/statusupdates/${contactId}/${opportunityId}`);
  }

  render() {
    const { opportunity, row, referral, userprofile } = this.props;
    const isClosed = _.get(opportunity, 'group', null) === 'CLOSED';
    const opportunityType = opportunity.type === 'Buyer' ? 'buying' : 'selling';
    const profileFullAddress = _.get(opportunity, 'contactProperty.property.address', null);
    const profileSteetAddress = _.get(opportunity, 'contactProperty.property.address.address1', null);
    const location = [];
    (opportunity.areasOfInterest || []).map(address => {
      if (!address.type?.includes('MLS') && location.length <= 0) {
        location.push(address.value);
      }
    });
    const ProfileCityStateZip = (location.length > 0) ? location : addressConcat(profileFullAddress || {});
    const opptaddresse = _.get(referral, 'addresses', []);
    const contactAddress = addressConcat(opptaddresse[0] || {});
    const opptNotes = _.get(opportunity, 'notes', []);
    const oppLeadSource = _.get(opportunity, 'leadSource', null);
    const oppLeadSubSource = _.get(opportunity, 'leadSubSource', null);

    const leadSource = _.get(referral, 'leadSources[0].leadSource', null);
    const leadSubSource = _.get(referral, 'leadSources[0].subLeadSource', null);
    const vettingQuestionInfo = _.get(opportunity, 'vattingQuestions', []);
    const publicNoteCount = opptNotes.filter(note => !!note.isPrivateToAdmins === false).length || '';
    let opportunitySource = '';
    if (oppLeadSubSource || leadSubSource) {
      opportunitySource = oppLeadSource ? `${oppLeadSource} / ${oppLeadSubSource}` : `${leadSource} / ${leadSubSource}`;
    }

    const lineOneAddress = location.length > 0 ? null : profileSteetAddress;
    let lineTwoAddress = ProfileCityStateZip;

    if ((opportunity.type === 'Seller') && (profileFullAddress == null) && location.length <= 0) {
      lineTwoAddress = contactAddress;
    }

    return (
      <React.Fragment>
        <div className='accordian-wrapper'>
          <div className='tab'>
            <input className='accordian-input' type='checkbox' id={`${row}chck2`} />
            <label className='tab-label primary-label' htmlFor={`${row}chck2`}>
              <div className='d-flex'>
                <div className='opportunity-icon'>
                  <span className={`lead-type-badge lead-${opportunityType}`} />
                </div>
                <div className='lead-type-wrapper'>
                  <div className='lead-type-text'>
                    {`${opportunityType[0].toUpperCase()}${opportunityType.slice(1)}`}
                  </div>
                </div>
                <div className='lead-address'>
                  <div className='line-address'>{lineOneAddress}</div>
                  <div className='line-address'>{lineTwoAddress}</div>
                </div>
              </div>
            </label>
            <div className='tab-content' >
              <div className='opportunity-status-container' onClick={this.redirectToWeeklyStatusUpdate}>
                <div className='status-badge' >
                  <StatusBadge statusGroup={this.props.opportunity.group} />
                </div>
                <div className='opportunity-text-container'>
                  <div className='status-label-text'> {!opportunity.status ? 'No Status' : opportunity.status}</div>
                  <div className='status-label'><img className='link-source-image' src={linkIcon} /> {opportunitySource} </div>
                </div>
                {!isClosed &&
                  <div className='weeklyupdate-icon-container'>
                    <div className='weeklyupdate-image'>
                      <img className='menu-logo-image' src={addIcon} onClick={() => this.redirectToWeeklyStatusUpdate()} />
                    </div>
                    <div className='weeklyupdate-text' >WEEKLY UPDATE</div>
                  </div>
                }
              </div>

              <div className='tab'>
                <input className='accordian-input' type='checkbox' id={`${row}chck3`} />
                <label className='tab-label' htmlFor={`${row}chck3`}>
                    <div className='ml-1 tab-wrapper'>
                        <div className='float-left'>
                            <img className='menu-logo-image' src={buyerProfileIcon} />
                        </div>
                        <div className='tab-wrapper opportunity-menu-text'><b>{opportunityType === 'buying' ? 'Buyer Profile' : 'Seller Profile'}</b></div>
                    </div>
                </label>
                <div className='tab-content'>
                  <div>
                    {opportunityType === 'buying'
                      ? <BuyingProfile opportunity={opportunity} />
                      : <SellingProfile opportunity={opportunity} />
                    }
                  </div>
                </div>
              </div>
              <div className='tab'>
                <input className='accordian-input' type='checkbox' id={`${row}chck4`} />
                <label className='tab-label' htmlFor={`${row}chck4`}>
                  <div className='ml-1 tab-wrapper'>
                    <div className='float-left'>
                        <img className='menu-logo-image' src={vettingQuestionsIcon} />
                    </div>
                    <div className='tab-wrapper opportunity-menu-text'><b>Vetting Questions</b></div>
                  </div>
                </label>
                <div className='tab-content'>
                  <VettingQuestions vettingQuestionInfo={vettingQuestionInfo} />
                </div>
              </div>
              <div className='tab'>
                <input className='accordian-input' type='checkbox' id={`${row}chck5`} />
                <label className='tab-label' htmlFor={`${row}chck5`}>
                  <div className='ml-1 tab-wrapper'>
                    <div className='float-left'>
                      <img className='menu-logo-image' src={propertyIcon} />
                    </div>
                    <div className='tab-wrapper opportunity-menu-text'><b>Property</b></div>
                    {!(_.get(opportunity, 'contactProperty.property', null)) &&
                      <div className='add-button-icon'>
                        <img className='menu-logo-image' src={addIcon}
                          onClick={() => this.props.addPropertyClickHandler(opportunity, 'Add Property')}
                        />
                      </div>
                    }
                  </div>
                </label>
                <div className='tab-content'>
                  {
                    opportunity.contactProperty && opportunity.contactProperty.property &&
                    <PropertyInfo property={opportunity.contactProperty.property} userprofile={userprofile} addPropertyClickHandler={this.props.addPropertyClickHandler} opportunity={opportunity} />
                  }
                </div>
              </div>
              <div className='tab'>
                <input className='accordian-input' type='checkbox' id={`${row}chck6`} />
                <label className='tab-label' htmlFor={`${row}chck6`}>
                  <div className='ml-1 tab-wrapper'>
                    <div className='float-left'>
                      <img className='menu-logo-image' src={notesIcon} />
                    </div>
                    <div className='header-align float-left tab-wrapper opportunity-menu-text'>
                      Notes {publicNoteCount > 0 ? ' (' + publicNoteCount + ')' : ''}
                    </div>
                    <div className='add-button-icon'>
                      {!isClosed &&
                        <img className='menu-logo-image' src={addIcon} onClick={() => this.redirectToWeeklyStatusUpdate()} />
                      }
                    </div>
                  </div>
                </label>
                <div className='tab-content'>
                  {opptNotes.map((data, index) => (
                    !data.isPrivateToAdmins &&
                    <div key={index} className='oppt-note-wrapper'>
                      <div>{data.note}</div>
                      <div>{moment(data.timestampEntered).format('MM/DD/YYYY hh:mm a')}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='tab'>
                <input className='accordian-input' type='checkbox' id={`${row}chck7`} />
                <label className='tab-label' htmlFor={`${row}chck7`}>
                    <div className='ml-1 tab-wrapper'>
                        <div className='float-left'>
                            <img className='menu-logo-image' src={documentsIcon} />
                        </div>
                        <div className='tab-wrapper opportunity-menu-text'><b>Documents</b></div>
                    </div>
                </label>
                <div className='tab-content'>
                  <Documents opportunity={opportunity} documents={this.props.documents}
                    showDocumentModal={this.props.showDocumentModal} showDocInModal={this.props.showDocInModal}
                    showReasonModal={this.props.showReasonModal}
                    referral={this.props.referral}
                    additionalDocuments={this.props.additionalDocuments}
                    markOpportunityDocumentRead={this.props.markOpportunityDocumentRead}
                  />
                </div>
              </div>

              <div className='tab opportunity-footer'>
                <div className='float-left opportunity-icons'>
                  <a href={`mailto:${opportunity.documentEmail}`} role='button'>EMAIL DOCS<i className='material-icons material-icons-email ml-2' /></a>
                </div>

                <CopyToClipboard text={opportunity.documentEmail} onCopy={() => { }}>
                  <div className='opportunity-icons'> COPY EMAIL
                    <i className='material-icons material-icons-content-copy ml-2' role='button' />
                  </div>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>

    );
  }
}

export default withRouter(Opportunities);
